module.exports = "<itpx-credit-application-form\n\t[accountId]=\"accountId\"\n></itpx-credit-application-form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/details/create-credit-application/create-credit-application.component.html
// module id = ./src/app/agora/components/account-data/accounts/details/create-credit-application/create-credit-application.component.html
// module chunks = main